"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletProviderErrorE = exports.WalletProviderE = void 0;
var WalletProviderE;
(function (WalletProviderE) {
    WalletProviderE["Ethereum"] = "Ethereum";
    WalletProviderE["Concordium"] = "Concordium";
})(WalletProviderE = exports.WalletProviderE || (exports.WalletProviderE = {}));
var WalletProviderErrorE;
(function (WalletProviderErrorE) {
    WalletProviderErrorE["REQUEST_PENDING"] = "requestPending";
    WalletProviderErrorE["USER_REJECTED_REQUEST"] = "userRejectedRequest";
    WalletProviderErrorE["INTERNAL_ERROR"] = "internalError";
    WalletProviderErrorE["UNKNOWN"] = "unknown";
})(WalletProviderErrorE = exports.WalletProviderErrorE || (exports.WalletProviderErrorE = {}));
